import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, SearchComponent, WmsTreeComponent } from '@wms/components';
import {BindTreeUtilsService, BindVariableService} from '@wms/services';
import { PageSelectComponent } from "@wms/app/components/bind-dialog/page-select/page-select.component";


@Component({
  selector: 'wms-bind-widgets',
  standalone: true,
  imports: [
    CommonModule,
    SearchComponent,
    WmsTreeComponent,
    PageSelectComponent
  ],
  templateUrl: './bind-widgets.component.html',
  styleUrls: ['./bind-widgets.component.less']
})
export class BindWidgetsComponent extends BaseComponent {

  widgetSearchKey: any;
  bindVariableService: BindVariableService;
  bindTreeService: BindTreeUtilsService;

  constructor() {
    super();
    this.bindTreeService = inject(BindTreeUtilsService);
    this.bindVariableService = inject(BindVariableService);
    /*get the widgets list*/
    if (!this.bindVariableService.isWidgetsLoaded) {
      this.bindVariableService.getWidgets();
    }
  }

  searchWidgets($event: any) {
    this.widgetSearchKey = $event.searchKey;
  }
}
